<script setup>
import { ref, computed, onMounted } from "vue";
import { useStore } from "vuex";
import MainContent from "./MainContent.vue";
import {
  FETCH_MY_COURSES_ACTION,
  GET_MY_COURSES,
} from "@/store/modules/USER/constants";

const store = useStore();

const chartCheck = ref(0);

onMounted(async () => {
  await fetchCourses();
});

const fetchCourses = async (page = null) => {
  await store.dispatch(`User/${FETCH_MY_COURSES_ACTION}`, page ? page : 1);
  chartCheck.value = +1;
};

const myCoursesData = computed(() => {
  return store.getters[`User/${GET_MY_COURSES}`];
});

const activeTab = ref("trainings");
</script>
<template>
  <div :key="chartCheck" class="flex h-full gap-5 flex-1">
    <MainContent
      :activeTab="activeTab"
      :TableData="myCoursesData?.data[0].courses"
      :courses="myCoursesData?.data[0]"
      @pagination_changed="
        (e) => {
          fetchCourses(e);
        }
      "
    />
  </div>
</template>